import React from 'react';

// Public (no login required) SMS program terms and privacy page.
//
// COMPLIANCE — Twilio toll-free verification requires a publicly accessible
// description of the messaging program, and carriers expect the privacy
// policy to state that mobile numbers are not shared with third parties for
// marketing. The URL of this page is submitted with the verification request
// (see docs/sms-toll-free-verification.md), so keep the route stable.
const SmsTermsPage = () => {
  return (
    <div className="container mt-5 mb-5" style={{ maxWidth: '760px' }}>
      <h1>Q-Car SMS Terms &amp; Privacy Policy</h1>
      <p className="text-muted">Last updated: August 25, 2026</p>

      <h4 className="mt-4">Program description</h4>
      <p>
        Q-Car Inspection Scan Alerts is an optional text message program for
        registered Q-Car dealership users. When a vehicle inspection QR code at
        your dealership is scanned, subscribers receive a text message alert
        from Q-Car with the vehicle details and a link to the inspection.
      </p>

      <h4 className="mt-4">Opting in</h4>
      <p>
        You can sign up from the <strong>Inspection Scan Text Alerts</strong>{' '}
        page inside your Q-Car account by entering your mobile number and
        checking the consent box. Consent is not a condition of purchasing or
        using any Q-Car service, and no one else can opt you in on your behalf.
        Message frequency varies based on inspection activity at your
        dealership. Message and data rates may apply.
      </p>

      <h4 className="mt-4">Opting out and help</h4>
      <p>
        Reply <strong>STOP</strong> to any message to cancel at any time, or
        turn alerts off from the Inspection Scan Text Alerts page in your
        account. After you opt out you will receive a single message confirming
        your unsubscription and nothing further. Reply <strong>HELP</strong> to
        any message for help, or contact your Q-Car representative.
      </p>

      <h4 className="mt-4">Privacy</h4>
      <p>
        Your phone number and text messaging opt-in status are used solely to
        deliver the alerts described above. No mobile information will be
        shared with third parties or affiliates for marketing or promotional
        purposes. Text messaging originator opt-in data and consent will not be
        sold or shared with any third parties.
      </p>
    </div>
  );
};

export default SmsTermsPage;
